import { Tooltip } from "antd";

import { ChartCardValue, ChartCardValuesProps } from "../ChartCard.types";
import {
  ChartValueContainer,
  Label,
  TooltipContainer,
  TooltipLabel,
  TooltipTitle,
  Value,
} from "./ChartSpecificValues.styles";

export function ChartSpecificValues({ values, isEmpty }: ChartCardValuesProps) {
  return (
    <ChartValueContainer isEmpty={isEmpty}>
      {values.map((currentValue: ChartCardValue, index: number) => (
        <Tooltip
          key={`${index}_${currentValue.label}_${currentValue.value}`}
          title={
            currentValue.tooltip?.title ? (
              <TooltipContainer>
                <TooltipTitle>{currentValue.tooltip.title}</TooltipTitle>
                <TooltipLabel>{currentValue.tooltip.label}</TooltipLabel>
              </TooltipContainer>
            ) : null
          }
          color="#4B4B4B"
          arrow={false}
          styles={{
            body: {
              minHeight: "48px",
              minWidth: "146px",
              borderRadius: "4px !important",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              textAlign: "center",
            },
          }}
        >
          <div
            key={`${currentValue.label}_${currentValue.value}_${index}`}
            style={{
              marginLeft: currentValue.value !== "" ? "10px" : undefined,
            }}
          >
            <Value>{currentValue.value}</Value>
            <Label>{currentValue.label}</Label>
          </div>
        </Tooltip>
      ))}
    </ChartValueContainer>
  );
}
